'use client';

import { c as _c } from "react/compiler-runtime";
import { useMandatoryContext } from '@repo/hooks';
import { ChainId } from '@repo/web3';
import { createContext, type PropsWithChildren } from 'react';
import { mainnetAddresses } from '@/helpers/addresses';
import { useUserTokenHolding } from '@/hooks/useUserTokenHolding';
interface TokenHolding {
  value: bigint | undefined;
  loading: boolean;
  refresh(hard?: boolean): void;
}
export interface MorphoLegacyProps {
  legacyMorphoHolding: TokenHolding;
  morphoHolding: TokenHolding;
}
export const MorphoLegacyContext = createContext<MorphoLegacyProps | null>(null);
export const useMorphoLegacyContext = () => {
  return useMandatoryContext(MorphoLegacyContext, "MorphoLegacyContext");
};
export type MorphoLegacyProviderProps = PropsWithChildren;
const MorphoLegacyContextProvider = t0 => {
  const $ = _c(6);
  const {
    children
  } = t0;
  const legacyMorphoHolding = useUserTokenHolding(mainnetAddresses.legacyMorphoToken, ChainId.Mainnet);
  const morphoHolding = useUserTokenHolding(mainnetAddresses.morphoToken, ChainId.Mainnet);
  let t1;
  if ($[0] !== legacyMorphoHolding || $[1] !== morphoHolding) {
    t1 = {
      legacyMorphoHolding,
      morphoHolding
    };
    $[0] = legacyMorphoHolding;
    $[1] = morphoHolding;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== children || $[4] !== t1) {
    t2 = <MorphoLegacyContext.Provider value={t1}>{children}</MorphoLegacyContext.Provider>;
    $[3] = children;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
export default MorphoLegacyContextProvider;